module.exports = __webpack_public_path__ + "img/periodo19.3cd2ff15.webp";